import React from 'react';
import PropTypes from 'prop-types';
import * as styles from './Footer.module.scss';

const Footer = () => (
  <div className={styles.Footer}>
      <a href="https://twitter.com/choci__" target="_blank">
        Copyright © 2021 △帽子フェスタ！？ copyright All Rights Reserved.
      </a>
  </div>
);

Footer.propTypes = {};

Footer.defaultProps = {};

export default Footer;
